export const translations = {
  en: {
    // Name
    name: "Sabbir Ahmed",

    // Navbar
    about: "About",
    skills: "Skills",
    experience: "Experience",
    projects: "Projects",
    education: "Education",
    githubProfile: "Github Profile",

    // Hero
    greeting: "Hi, I am",
    iAmA: "I am a",
    checkResume: "Check Resume",
    checkResumeJP: "Resume (日本語)",

    // Bio
    description:
      "Looking for a position as a software engineer and enjoy putting new technology into practice. Possess strong skills in programming languages, OOP, data structures, and algorithms.",
    roles: ["Full Stack Developer", "Backend Developer", "Problem Solver"],

    // Skills
    skillsTitle: "Skills",
    skillsDesc:
      "Here are some of my skills on which I have been working on for the past 3+ years.",
    skillCategories: {
      Frontend: "Frontend",
      Backend: "Backend",
      Others: "Others",
    },

    // Experience
    experienceTitle: "Experience",
    experienceDesc:
      "My work experience as a software engineer and working on different companies and projects.",
    skillsLabel: "Skills:",
    experiences: {
      0: {
        role: "Software Engineer",
        company: "Human Resocia",
        date: "Nov 2024 - Present",
        desc: "Migrated a trade management system from VB.Net to C# and React. Developed screens, created APIs, handled invoice and inventory features, and fixed bugs. Worked in an Agile team with full Japanese communication.",
      },
      1: {
        role: "Software Engineer",
        company: "Elysium",
        date: "Jan 2026 - Present",
        desc: "Working as frontend React + TypeScript, backend Ruby, C++, C#, and CI/CD. Contributing to their internal 3D/CAD project.",
      },
      2: {
        role: "Associate Software Engineer",
        company: "Kaz",
        date: "Nov 2021 - Oct 2023",
        desc: "Led the development of diverse applications, from a conference scheduling app with .Net Core, MySQL, Twilio, AWS, ReactJs, Redux, to a US Stock Market analysis app with similar tech stack. Also, contributed to an in-house Leave Management System. Actively involved in training junior software trainees.",
      },
      3: {
        role: "Junior Software Engineer",
        company: "Present IT Solutions",
        date: "Aug 2020 - Oct 2021",
        desc: "Built a school management system with ASP.Net Core MVC and SQL Server, and a robust e-Commerce web app using .Net Core 3.1, SQL Server, and ReactJS, serving a retail store with 100k customers.",
      },
    },

    // Projects
    projectsTitle: "Projects",
    projectsDesc:
      "I have worked on a wide range of projects. From web apps to android apps. Here are some of my projects.",
    all: "ALL",
    professionalProjects: "Professional Projects",
    universityProjects: "University Projects",
    viewCode: "View Code",
    viewLiveApp: "View Live App",
    members: "Members",
    projectData: {
      0: {
        title: "ePortNet",
        date: "Nov 2024 - Present",
        description:
          "Migrated legacy trade system (ePortNet) from VB.Net to C# (.NET Core) and React. Developed UI, REST APIs, handled invoicing and inventory, and fixed bugs. Worked fully in Japanese using SQL Server/Oracle.",
      },
      1: {
        title: "Gateway To Access",
        date: "Feb 2022 - Oct 2023",
        description:
          "Gateway to Access provides Web, Desktop, and Mobile apps for providing interpretation services where users(doctors/lawyers) can take the help of interpreters to communicate with their patients/clients in their native language through remote(audio/video) or face-to-face service in real time or by the pre-scheduled meeting. My major responsibilities are implementing core features, working on multiple server-side projects using C#(.NET 6), configuring and managing various AWS cloud services, designing Database schemas, and developing web UI using React.",
      },
      2: {
        title: "Roostpad",
        date: "Nov 2021 - Jan 2022",
        description:
          "In-house Leave Management System with seamless integration, utilizing .Net Core Web API for robust backend functionality, MySQL for efficient data management, and ReactJs for a user-friendly and responsive frontend, ensuring a streamlined and effective leave management process.",
      },
      3: {
        title: "School Management System",
        date: "Oct 2022 - Jan 2023",
        description:
          "Developed a comprehensive school management system with a focus on student management, teacher management, and exam management, using .Net Core for backend functionality, SQL Server for database management, and ReactJs for a dynamic and responsive frontend.",
      },
      4: {
        title: "E-Commerce",
        date: "Sep 2019 - Feb 2020",
        description:
          "Develop a comprehensive E-Commerce application using ASP.NET Core 3.1 MVC and MSSQL, organized within the e-Commerce solution directory. The project incorporates C#, HTML, CSS, and SCSS, utilizing tools such as Visual Studio 2019, MSSQL Server Management Studio, and Bootstrap. The application follows a web-based architecture and is structured with three main components: Libraries (ECommerce.Core, ECommerce.Data), and ECommerce.Web, ensuring modular and maintainable code for efficient development and scalability.",
      },
    },

    // Education
    educationTitle: "Education",
    educationDesc:
      "My education has been a journey of self-discovery and growth. My educational details are as follows.",
    gradeLabel: "Grade :",
    educationData: {
      0: {
        school: "Comilla University, Cumilla",
        date: "Mar 2015 - Feb 2020",
        desc: "I completed bachelor at Comilla University, Cumilla, where I studied Computer Science and Engineering. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others.",
        degree: "Bachelor of Science - BSc, Computer Science and Engineering",
        grade: " CGPA - 3.04",
      },
      1: {
        school: "Cumilla Shikkha Board Govt. Model College, Cumilla",
        date: "Aug 2012 - Apr 2014",
        desc: "I completed my high school and college education at Cumilla Shikkha Board Govt. Model College, Cumilla, where I studied Science.",
        degree: "HSC(XII)",
        grade: " GPA - 5.00",
      },
    },

    // Footer
    copyright: "© 2026 Sabbir Ahmed. All rights reserved.",

    // Language
    langLabel: "EN",
  },
  ja: {
    // Name
    name: "サッビル　アメド",

    // Navbar
    about: "紹介",
    skills: "スキル",
    experience: "経験",
    projects: "プロジェクト",
    education: "学歴",
    githubProfile: "Githubプロフィール",

    // Hero
    greeting: "こんにちは、",
    iAmA: "",
    checkResume: "履歴書を見る",
    checkResumeJP: "履歴書（日本語）",

    // Bio
    description:
      "ソフトウェアエンジニアとしてのポジションを求めており、新しい技術を実践に活かすことを楽しんでいます。プログラミング言語、OOP、データ構造、アルゴリズムに強いスキルを持っています。",
    roles: [
      "フルスタック開発者",
      "バックエンド開発者",
      "問題解決者",
    ],

    // Skills
    skillsTitle: "スキル",
    skillsDesc: "3年以上取り組んできたスキルの一部をご紹介します。",
    skillCategories: {
      Frontend: "フロントエンド",
      Backend: "バックエンド",
      Others: "その他",
    },

    // Experience
    experienceTitle: "経験",
    experienceDesc:
      "ソフトウェアエンジニアとして、さまざまな企業やプロジェクトでの実務経験です。",
    skillsLabel: "スキル：",
    experiences: {
      0: {
        role: "ソフトウェアエンジニア",
        company: "ヒューマンリソシア",
        date: "2024年11月 - 現在",
        desc: "VB.NetからC#およびReactへの貿易管理システムの移行を担当。画面開発、API作成、請求書・在庫機能の実装、バグ修正を行いました。日本語でのコミュニケーションを行うアジャイルチームで勤務。",
      },
      1: {
        role: "ソフトウェアエンジニア",
        company: "エリジウム",
        date: "2026年1月 - 現在",
        desc: "フロントエンドReact + TypeScript、バックエンドRuby、C++、C#、CI/CDを担当。社内の3D/CADプロジェクトに貢献。",
      },
      2: {
        role: "アソシエイトソフトウェアエンジニア",
        company: "Kaz",
        date: "2021年11月 - 2023年10月",
        desc: ".Net Core、MySQL、Twilio、AWS、ReactJs、Reduxを使用した会議スケジュールアプリから、同様の技術スタックを使用した米国株式市場分析アプリまで、多様なアプリケーションの開発をリード。また、社内の休暇管理システムにも貢献。ジュニアソフトウェアトレーニーの指導にも積極的に関与。",
      },
      3: {
        role: "ジュニアソフトウェアエンジニア",
        company: "Present ITソリューションズ",
        date: "2020年8月 - 2021年10月",
        desc: "ASP.Net Core MVCとSQL Serverを使用した学校管理システム、および.Net Core 3.1、SQL Server、ReactJSを使用した堅牢なeコマースウェブアプリを構築。10万人の顧客を持つ小売店向け。",
      },
    },

    // Projects
    projectsTitle: "プロジェクト",
    projectsDesc:
      "ウェブアプリからモバイルアプリまで、幅広いプロジェクトに携わってきました。以下はその一部です。",
    all: "すべて",
    professionalProjects: "業務プロジェクト",
    universityProjects: "大学プロジェクト",
    viewCode: "コードを見る",
    viewLiveApp: "ライブアプリを見る",
    members: "メンバー",
    projectData: {
      0: {
        title: "ePortNet",
        date: "2024年11月 - 現在",
        description:
          "レガシー貿易システム（ePortNet）をVB.NetからC#（.NET Core）およびReactに移行。UI、REST APIを開発し、請求書発行や在庫管理を担当し、バグを修正。SQL Server/Oracleを使用し、完全に日本語で業務を遂行。",
      },
      1: {
        title: "Gateway To Access",
        date: "2022年2月 - 2023年10月",
        description:
          "Gateway to Accessは、通訳サービスを提供するWeb、デスクトップ、モバイルアプリを提供し、ユーザー（医師/弁護士）がリモート（音声/ビデオ）や対面サービスを通じて、通訳者の助けを借りて患者/クライアントと母国語でコミュニケーションできるようにします。主な責任はコア機能の実装、C#（.NET 6）を使用した複数のサーバーサイドプロジェクト、各種AWSクラウドサービスの構成・管理、データベーススキーマの設計、Reactを使用したWeb UIの開発です。",
      },
      2: {
        title: "Roostpad",
        date: "2021年11月 - 2022年1月",
        description:
          "シームレスな統合を備えた社内休暇管理システム。.Net Core Web APIによる堅牢なバックエンド機能、MySQLによる効率的なデータ管理、ReactJsによるユーザーフレンドリーでレスポンシブなフロントエンドを活用し、合理化された効果的な休暇管理プロセスを実現。",
      },
      3: {
        title: "学校管理システム",
        date: "2022年10月 - 2023年1月",
        description:
          "生徒管理、教師管理、試験管理に焦点を当てた包括的な学校管理システムを開発。バックエンド機能に.Net Core、データベース管理にSQL Server、動的でレスポンシブなフロントエンドにReactJsを使用。",
      },
      4: {
        title: "Eコマース",
        date: "2019年9月 - 2020年2月",
        description:
          "ASP.NET Core 3.1 MVCとMSSQLを使用した包括的なEコマースアプリケーションを開発。eコマースソリューションディレクトリ内で構成。C#、HTML、CSS、SCSSを採用し、Visual Studio 2019、SQL Server Management Studio、Bootstrapなどのツールを活用。Webベースのアーキテクチャに従い、ライブラリ（ECommerce.Core、ECommerce.Data）とECommerce.Webの3つの主要コンポーネントで構成され、効率的な開発とスケーラビリティのためのモジュラーで保守可能なコードを確保。",
      },
    },

    // Education
    educationTitle: "学歴",
    educationDesc:
      "私の教育は自己発見と成長の旅でした。学歴の詳細は以下の通りです。",
    gradeLabel: "成績：",
    educationData: {
      0: {
        school: "コミラ大学、コミラ",
        date: "2015年3月 - 2020年2月",
        desc: "コミラ大学コミラ校でコンピュータサイエンスおよびエンジニアリングを専攻し、学士課程を修了しました。データ構造、アルゴリズム、オブジェクト指向プログラミング、データベース管理システム、オペレーティングシステム、コンピュータネットワークなどの科目を履修しました。",
        degree: "理学士 - BSc、コンピュータサイエンスおよびエンジニアリング",
        grade: " CGPA - 3.04",
      },
      1: {
        school: "コミラ教育委員会政府モデルカレッジ、コミラ",
        date: "2012年8月 - 2014年4月",
        desc: "コミラ教育委員会政府モデルカレッジ、コミラで高校および大学教育を修了し、理系を専攻しました。",
        degree: "HSC（XII）",
        grade: " GPA - 5.00",
      },
    },

    // Footer
    copyright: "© 2026 サッビル　アメド. 全著作権所有。",

    // Language
    langLabel: "日本語",
  },
};

